import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/admin/map-editor/map-editor.component.scss.shim.ngstyle.ts